import { render, staticRenderFns } from "./JxLogin.vue?vue&type=template&id=b91994f0&scoped=true&"
import script from "./JxLogin.vue?vue&type=script&lang=js&"
export * from "./JxLogin.vue?vue&type=script&lang=js&"
import style0 from "./JxLogin.vue?vue&type=style&index=0&id=b91994f0&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b91994f0",
  null
  
)

export default component.exports